export class CompanyFile {
    public id: number | null;
    public document_name: string ;
    public created_by_user: string ;
    public createdAt: Date|null;

    constructor(data: CompanyFileData | void) {
        if (data === undefined) {
            this.id = null;
            this.document_name = "";
            this.created_by_user = "";
            this.createdAt = null;

        } else {
            this.id = data.id;
            this.document_name = data.document_name;
            this.created_by_user = data.created_by_user;
            this.createdAt = data.createdAt;

        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.document_name = "";
        this.created_by_user = "";
        this.createdAt = null;

    }
    serializeData():CompanyFileData {
        return {
            id: this.id,
            document_name: this.document_name,
            created_by_user: this.created_by_user,
            createdAt: this.createdAt,

        }
    }
}

export type CompanyFileData = {
    id:number|null;
    document_name:string;
    created_by_user:string;
    createdAt:Date|null;

}